import ImageWithBasePath from "@/components/image-with-base-path"
import { all_routes } from "@/routes/all_routes"
import { Link } from "react-router"

const BlogsSection = () => {
  return (
   <>
  {/* Blogs Section Start */}
  <section className="blog-section-fourteen section">
    <div className="container">
      <div
        className="section-header section-header-fourteen text-center wow fadeInUp"
        data-wow-duration="1s"
      >
        <h2 className="section-title">
          Check Out <span className="section-line">Latest</span>{" "}
          <span className="subtitle">News &amp; Articles</span>
        </h2>
      </div>
      {/* start row */}
      <div className="row g-4 justify-content-center">
        {/* Item 1 */}
        <div className="col-lg-4 col-md-6 col-sm-6">
          <div
            className="blog-item-fourteen wow fadeInUp"
            data-wow-duration="1s"
          >
            <div className="blog-img">
              <ImageWithBasePath
                src="assets/img//blog/skin-blog-01.jpg"
                alt="blogs"
                className="img-fluid"
              />
              <div className="blog-date">
                26 <span>Apr</span>
              </div>
            </div>
            <div className="blog-content">
              <div className="blog-tags">
                <Link to={all_routes.blogGrid} className="badge bg-light text-dark">
                  Skincare Tips
                </Link>
                <p className="mb-0">
                  <i className="isax isax-messages-15 me-2" />
                  Comments (5)
                </p>
              </div>
              <h3 className="custom-title">
                <Link to={all_routes.blogDetails}>
                  The Ultimate Guide to Glowing Skin: Morning &amp; Night
                  Routines
                </Link>
              </h3>
            </div>
          </div>
        </div>
        {/* Item 2 */}
        <div className="col-lg-4 col-md-6 col-sm-6">
          <div
            className="blog-item-fourteen wow fadeInUp"
            data-wow-duration="1s"
          >
            <div className="blog-img">
              <ImageWithBasePath
                src="assets/img/blog/skin-blog-02.jpg"
                alt="blogs"
                className="img-fluid"
              />
              <div className="blog-date">
                30 <span>Mar</span>
              </div>
            </div>
            <div className="blog-content">
              <div className="blog-tags">
                <Link to={all_routes.blogGrid} className="badge bg-light text-dark">
                  Product Reviews
                </Link>
                <p className="mb-0">
                  <i className="isax isax-messages-15 me-2" />
                  Comments (2)
                </p>
              </div>
              <h3 className="custom-title">
                <Link to={all_routes.blogDetails}>
                  Top 5 Sunscreens for Sensitive Skin in 2026
                </Link>
              </h3>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-6">
          <div
            className="blog-item-fourteen wow fadeInUp"
            data-wow-duration="1s"
          >
            <div className="blog-img">
              <ImageWithBasePath
                src="assets/img/blog/skin-blog-01.jpg"
                alt="blogs"
                className="img-fluid"
              />
              <div className="blog-date">
                28 <span>Mar</span>
              </div>
            </div>
            <div className="blog-content">
              <div className="blog-tags">
                <Link to={all_routes.blogGrid} className="badge bg-light text-dark">
                  DIY Remedies
                </Link>
                <p className="mb-0">
                  <i className="isax isax-messages-15 me-2" />
                  Comments (7)
                </p>
              </div>
              <h3 className="custom-title">
                <Link to={all_routes.blogDetails}>
                  Natural Ingredients That Can Help Combat Acne
                </Link>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* Blogs Section end */}
</>

  )
}

export default BlogsSection